import { render, staticRenderFns } from "./BannerVideoSection.vue?vue&type=template&id=56fa435a"
import script from "./BannerVideoSection.vue?vue&type=script&lang=ts"
export * from "./BannerVideoSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports